/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Meta_ConnectInputs */

const cs_settings_meta_connect = /** @type {(inputs: Settings_Meta_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojit osobní Meta`)
};

const en_settings_meta_connect = /** @type {(inputs: Settings_Meta_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect personal Meta`)
};

/**
* | output |
* | --- |
* | "Connect personal Meta" |
*
* @param {Settings_Meta_ConnectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_meta_connect = /** @type {((inputs?: Settings_Meta_ConnectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Meta_ConnectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_meta_connect(inputs)
	return cs_settings_meta_connect(inputs)
});